import React, { useRef } from 'react';
import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import { Alert, Container, Modal, Row } from 'react-bootstrap';
import { ListDocs } from '../../utils/ListDocs.tsx';
//import "react-datepicker/dist/react-datepicker.css";
import ReactDatePicker from 'react-datepicker';
import { registerLocale } from "react-datepicker";
import es from 'date-fns/locale/es';
import { ListReportantes } from '../../utils/ListReportantes.tsx';
import { ListClinicas } from '../../utils/ListClinicas.tsx';
import '../../../../common/styles/form.scss'
import '../../../../common/styles/react-datepicker.css'
import { validadordeDerechoApi } from '../../../../common/services/apis/validadordeDerecho.ts'
import axios from 'axios';
import moment from 'moment';
import { VerticallyModal } from './ModalDinamic.tsx';
import { radicarSolicitudApi } from '../../../../common/services/apis/radicarSolicitud.ts';
import { ConfirmarSolicitudApi, iniciarSolicitudApi, ConsultarAseguramientoApi } from '../../../../common/services/apis/mftSolicitudApi.ts';
import ReCAPTCHA from 'react-google-recaptcha';
import { ENV_CONFIG } from '../../../../config/config.ts';
import Spinner from 'react-bootstrap/Spinner'
import { tokenApi } from '../../../../common/services/apis/tokenApi.ts';
import dotenv from 'dotenv';



const CryptoJS = require('crypto-js');

registerLocale('es', es)

interface appI {
    llave_recaptcha: string,
    tiposDocs: any,
    reportantes: any,
    clinicas: any
}


export const FormularioExternoSPC = ({ tiposDocs, reportantes, clinicas, llave_recaptcha }: appI) => {


    const [validated, setValidated] = useState(false);
    const [hiddenLoading, setHiddenLoading] = useState(true);
    const [selectTipoId, setSelectTipoId] = useState("");
    const [selectReportante, setSelectReportante] = useState("");
    const [valueGenero, setSelectGenero] = useState("");
    const [valueClinica, setSelectClinica] = useState("");
    const [startOcurrenceDate, setStartOcurrenceDate] = useState<any | null>(null);
    const [startBornDate, setStartBornDate] = useState<any | null>(null);
    const [MaximoNumeroIdentificacion, setMaximoNumeroIdentificacion] = useState(15);
    const [MinimoNumeroIdentificacion, setMinimoNumeroIdentificacion] = useState(3);
    const [MaximoNumeroIdentificacionReportante, setMaximoNumeroIdentificacionReportante] = useState(15);
    const [MinimoNumeroIdentificacionReportante, setMinimoNumeroIdentificacionReportante] = useState(3);
    const [validarDato, setValidarDato] = useState(false);
    const [valueNumerodeIdentificacion, setValueNumeroIdentificacion] = useState('');
    const [valueNumerodeIdentificacionReportante, setValueNumeroIdentificacionReportante] = useState('');
    const [valueEdad, setValueEdad] = useState('');

    const [valueNombrePaciente, setValueNombrePaciente] = useState("");
    const [valueAseguramiento, setValueAseguramiento] = useState("");
    const [valueDescripcionEvento, setDescripcionEvento] = useState<any | null>("");
    const [valuecargararchivo, setcargararchivo] = useState("valor")
    const [modalShow, setModalShow] = useState(false);

    const [valueEquipos, setValueEquipos] = useState("");
    const [valueMotivoTramite, setMotivoTramite] = useState("");
    const [valueToken, setValueToken] = useState("");
    const [bodyForm, setBodyForm] = useState(new FormData());
    const [nombreAdjuntos, setNombreAdjuntos] = useState("");
    const recaptchaRef = useRef<HTMLInputElement>(null)
    //Variables para inicializar y cerrar modal

    const [valueCuerpoMensaje, setCuerpoMensaje] = useState('');
    const [valueTituloMensaje, setTituloMensaje] = useState('');
    const [valueRadicacion, setRadicacion] = useState('');
    const [valueIdDocumento, setIdDocumento] = useState();


    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [isDisabledIdentificacion, setIsDisabledIdentificacion] = useState(false);


    let listDocs;
    let listReportantes;
    let lstClinicas;

    const [recaptchaValido, setRecaptchaValido] = useState(true);
    const [requeridoFechaoOcurrencia, setRequeridoFechaOcurrencia] = useState(true);
    const [eliminarRequerido, setEliminarRequerido] = useState(null);

    const LimpiarCampos = () => {
        setValueNombrePaciente("")
        setValueAseguramiento("")
        setValueEdad('');
        setValueNumeroIdentificacion("")
        setSelectGenero("");
        setValueEquipos("");
        setDescripcionEvento("");
        setStartOcurrenceDate("");
        setStartBornDate("");
        setSelectClinica("");
        setSelectReportante("");
        setSelectTipoId("");
        setcargararchivo("");


    };

    const LimpiarCamposPaciente = () => {
        setValueNombrePaciente("")
        setValueAseguramiento("")
        setStartBornDate("")
        setValueEdad('');
        setSelectGenero("");
    };

    const onKeyDown = async (e: any) => {

        try {
            if (selectTipoId !== "" && valueNumerodeIdentificacion !== "") {
                let data;
                let token = await tokenApi.then((tokenresultado) => tokenresultado);
                const desToken = token.data.split(',');
                const keyBytes = CryptoJS.enc.Base64.parse(process.env.REACT_APP_KEY_SECRET);
                let dataEncr = valueIdDocumento + "@" + valueNumerodeIdentificacion;
                const encrypted = CryptoJS.AES.encrypt(dataEncr, keyBytes,
                    {
                        mode: CryptoJS.mode.ECB,
                        padding: CryptoJS.pad.Pkcs7
                    }
                );
                const encryptedText = encrypted.ciphertext.toString(CryptoJS.enc.Base64);
                const numeroToken = desToken[1].split('=');
                const url = `/ValidadorDerechos`;
                const postData: any = {
                    "data": encryptedText
                };
                let datos = await validadordeDerechoApi(numeroToken[1]).post(url, postData).then((resultado) => (data = (resultado.data.consultarPorIdentificacion)));

                if (datos.return.datosContratosDTO.length > 0) {
                    setValueEdad(datos.return.datosContratosDTO[0].datosUsuariosDTO[0].edad)
                    setValueNombrePaciente(datos.return.datosContratosDTO[0].datosUsuariosDTO[0].nombre.replaceAll('_', ' ').replace(',', ' '))
                    setSelectGenero(datos.return.datosContratosDTO[0].datosUsuariosDTO[0].sexo)
                    const date = moment(datos.return.datosContratosDTO[0].datosUsuariosDTO[0].fecNacim, 'DD-MM-YYYY')
                    const fec = new Date(date.toString());
                    setStartBornDate(fec)
                }

                //CONSULTANDO INFORMACION DE ASEGURAMIENTO                  
                const objectRequest = JSON.stringify({
                    documentType: valueIdDocumento,
                    document: valueNumerodeIdentificacion
                });

                console.log('Consultando Aseguramiento '+objectRequest);

                let getAseguramiento = await ConsultarAseguramientoApi(objectRequest, numeroToken[1]);

                if (getAseguramiento.status === 200) {
                    setValueAseguramiento(getAseguramiento.data);
                }

                else {
                    //EL mockup no muestra en donde esta este mensaje
                    LimpiarCamposPaciente()
                }
            }
        }
        catch (e) {
            // mensajeModal("Error","No se radicó la solicitud: se presentó un error interno",'')
            // setHiddenLoading(true)
        }
    };

    //Validaciones solo numero para ciertos tipos de numero de documentos
    const handleChange = (event: any) => {

        //Validaciones numericas        
        if (event.target.name == 'numero_identificacion') {
            if (validarDato == true) {
                const result = event.target.value.replace(/\D/g, '');
                setValueNumeroIdentificacion(result);
            }
            else {
                const valor = event.target.value;
                const regMatch = /^[a-zA-Z0-9]*$/.test(event.target.value);
                if (regMatch == true) {
                    setValueNumeroIdentificacion(valor);
                }


            }
        }

        if (event.target.name == 'aseguramiento') {
            const valor = event.target.value;
            const regMatch = /^[a-zA-Z0-9 ,]*$/.test(event.target.value);
            if (regMatch == true) {
                setValueAseguramiento(valor);
            }
        }

        if (event.target.name == 'numero_reportante') {
            if (validarDato == true) {
                const result = event.target.value.replace(/[^a-zA-Z0-9]/g, '');
                setValueNumeroIdentificacionReportante(result);
            }
            else {
                const valor = event.target.value;
                const regMatch = /^[a-zA-Z0-9]*$/.test(event.target.value);
                if (regMatch == true) {
                    setValueNumeroIdentificacionReportante(valor);
                }


            }
        }

        if (event.target.name == 'genero') {
            const regMatch = /^[a-zA-Z]*$/.test(event.target.value);
            if (regMatch == true) {
                const valor = event.target.value;
                if (valor.toUpperCase() == 'M' || valor.toUpperCase() == 'F') {
                    setSelectGenero(valor.toUpperCase());
                }
                else {
                    setSelectGenero('')
                }
            }
        }
        if (event.target.name == 'edad') {
            const result = event.target.value.replace(/\D/g, '');
            setValueEdad(result);
        }

        if (event.target.name == 'nombres_paciente') {
            setValueNombrePaciente(event.target.value);
        }

        if (event.target.name == 'equipos_medicos') {
            setValueEquipos(event.target.value);
        }

        if (event.target.name == 'descripcionevento') {
            setDescripcionEvento(event.target.value);
        }
    };

    const mensajeModal = (titulo: any, cuerpoMensaje: any, radicacion: any) => {
        setTituloMensaje(titulo);
        setCuerpoMensaje(cuerpoMensaje);
        setRadicacion(radicacion)
        setModalShow(true);
    }

    const Onchange2 = (event: any) => {
        setEliminarRequerido(event)
        if (event != null) {
            setRecaptchaValido(true)
        }
        else {
            setRecaptchaValido(false);
        }
    };

    //Validaciones para tamaño y tipo de archivo
    const ValidarTamano = async (obj: any) => {

        let archivoIncorrecto;

        bodyForm.forEach(function (val: any, key: any, fD: any) {
            bodyForm.delete(key);
        });

        var TemporalTamanoArchivos = 0; // Tamaño temporal de subida 5mb
        const tamanoPermitid = 5000000;
        for (let index = 0; index < obj.target.files.length; index++) {
            const valor = obj.target.files[index].size;
            const typeFile = obj.target.files[index].type

            const tipoarchivo = obj.target.files[index].name.split('.')[1].toUpperCase();

            //archivos permitidos 
            if (typeFile == 'application/pdf'
                || typeFile == 'image/jpeg' || typeFile == 'image/jpg'
                || typeFile == 'image/png'
                || typeFile == 'application/x-zip-compressed'
                || typeFile == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                || typeFile == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                || typeFile == 'application/vnd.oasis.opendocument.text'
                || typeFile == 'application/octet-stream' || tipoarchivo == 'SLS') {
                var Nombre = moment().format('DDMMYYYHmmss')
                TemporalTamanoArchivos = (TemporalTamanoArchivos + valor);

                // Validación tamaño del archivo
                if (tamanoPermitid >= TemporalTamanoArchivos) {
                    setNombreAdjuntos(nombreAdjuntos.concat("," + (Nombre + obj.target.files[index].name)));
                    bodyForm.append('file', obj.target.files[index], (Nombre + obj.target.files[index].name));
                    setBodyForm(bodyForm);
                }
                else {
                    archivoIncorrecto = true;
                }
            }
            else {
                archivoIncorrecto = true;
            }

        }

        if (archivoIncorrecto == true) {
            obj.target.value = null;
            mensajeModal('Archivos inválidos', 'Formatos permitidos: ZIP, PDF, XLSX, SLS, ODT, DOCX, PNG, JPG, JPEG. Máximo tamaño permitido 5:MB', '');
            TemporalTamanoArchivos = 0;
        }

    };

    const [isDisabled, setIsDisabled] = useState(false);

    const EnviarSolicitud = async () => {

        try {

            setIsDisabled(true);
            setHiddenLoading(false)

            let token = await tokenApi.then((tokenresultado) => tokenresultado);

            const desToken = token.data.split(',');

            const numeroToken = desToken[1].split('=');

            if (bodyForm) {
                bodyForm.append('file', "");
            }

            let datosInicio = await iniciarSolicitudApi(numeroToken[1], bodyForm)
                .then((resultado) => resultado);
            if (datosInicio.status == 200) {
                if (!startBornDate) {
                    const ObjetoSolicitud = JSON.stringify({
                        tipoIdentifiacionPaciente: selectTipoId,
                        numeroIdentificacionPaciente: valueNumerodeIdentificacion,
                        nombrePaciente: valueNombrePaciente,
                        aseguramiento: valueAseguramiento,
                        correoContacto: "notiene@hotmail.com",
                        nivelDeEscalamiento: "https://aquiles.colsanitas.com/flujoSeguridadPaciente-webapp/restful/objects/NivelEscalamiento/4",
                        motivoTramite: valueMotivoTramite,
                        fechaOcurrencia: moment(startOcurrenceDate).format('YYYY-MM-DD') + "T10:01:00.239Z",
                        reportante: selectReportante,
                        clinicaEvento: valueClinica,
                        equiposMedicos: valueEquipos,
                        fechaNacimiento: "1900-01-01T10:00:00.239Z",
                        edad: valueEdad,
                        genero: valueGenero,
                        numeroReportante: valueNumerodeIdentificacionReportante,
                        descripcionEvento: valueDescripcionEvento,
                        submitFormLink: datosInicio.data
                    });

                    let datosConfirmarSolicitud = await ConfirmarSolicitudApi(ObjetoSolicitud, numeroToken[1])
                    if (datosConfirmarSolicitud.status == 200) {

                        const dataMFT = datosConfirmarSolicitud.data.data.message.split(';');
                        const numeroMFT = dataMFT[0];
                        mensajeModal("¡Gracias por contactarte con nosotros!", "Tu información se envío exitosamente, con los siguientes datos:", 'Radicación N°: ' +
                            numeroMFT + ' el ' + moment(dataMFT[1], 'DD/MM/YYYY HH:mm').format('DD/MM/YYYY') + ' a las ' + moment(dataMFT[1], 'DD/MM/YYYY HH:mm').format('HH:mm'))
                        LimpiarCampos();
                        setHiddenLoading(true)
                    }
                }
                else {
                    const ObjetoSolicitud = JSON.stringify({
                        tipoIdentifiacionPaciente: selectTipoId,
                        numeroIdentificacionPaciente: valueNumerodeIdentificacion,
                        nombrePaciente: valueNombrePaciente,
                        aseguramiento: valueAseguramiento,
                        correoContacto: "notiene@hotmail.com",
                        nivelDeEscalamiento: "https://aquiles.colsanitas.com/flujoSeguridadPaciente-webapp/restful/objects/NivelEscalamiento/4",
                        motivoTramite: valueMotivoTramite,
                        fechaOcurrencia: moment(startOcurrenceDate).format('YYYY-MM-DD') + "T10:01:00.239Z",
                        reportante: selectReportante,
                        clinicaEvento: valueClinica,
                        equiposMedicos: valueEquipos,
                        fechaNacimiento: moment(startBornDate).format('YYYY-MM-DD') + "T10:00:00.239Z",
                        edad: valueEdad,
                        genero: valueGenero,
                        numeroReportante: valueNumerodeIdentificacionReportante,
                        descripcionEvento: valueDescripcionEvento,
                        submitFormLink: datosInicio.data
                    });

                    let datosConfirmarSolicitud = await ConfirmarSolicitudApi(ObjetoSolicitud, numeroToken[1])
                    if (datosConfirmarSolicitud.status == 200) {

                        const dataMFT = datosConfirmarSolicitud.data.data.message.split(';');
                        const numeroMFT = dataMFT[0];
                        mensajeModal("¡Gracias por contactarte con nosotros!", "Tu información se envío exitosamente, con los siguientes datos:", 'Radicación N°: ' +
                            numeroMFT + ' el ' + moment(dataMFT[1], 'DD/MM/YYYY HH:mm').format('DD/MM/YYYY') + ' a las ' + moment(dataMFT[1], 'DD/MM/YYYY HH:mm').format('HH:mm'))
                        LimpiarCampos();
                        setHiddenLoading(true)
                    }
                }
            }
            else {
                mensajeModal("", "Lo sentimos estamos presentando inconvenientes. Inténtalo más tarde.", '')
                setHiddenLoading(true)
            }

        }
        catch (e) {
            mensajeModal("", "Lo sentimos estamos presentando inconvenientes. Inténtalo más tarde.", '')
            setHiddenLoading(true)
        } finally {
            setIsDisabled(false);
        }
    };

    const handleSubmit = (event: any) => {

        const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();

        //  Colocar esta linea colocar obligatorio el recapchat
        
        if(eliminarRequerido == null) {
            setRecaptchaValido(false);
            return;
        }
        

        if (!startOcurrenceDate) {
            setRequeridoFechaOcurrencia(false);
            setValidated(true);
            return;
        }
        else {
            setRequeridoFechaOcurrencia(true);
        }
        if (!valueDescripcionEvento) {
            setValidated(true);
            return;
        }

        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
            setValidated(true);
            return;
        }
        else {
            setValidated(false);
            EnviarSolicitud();
        }
        //hasta aca para el recapchat
        // colocar esta linea
        /*
        if(eliminarRequerido != null) {
            setValidated(false);
            EnviarSolicitud();  
        }
        */
        //hasta aca
    };

    const ValidacionMaximoMinimo = async (tipoDocumento: any) => {
        LimpiarCampos();
        setValidarDato(false);
        setMaximoNumeroIdentificacion(15);
        setMinimoNumeroIdentificacion(1);
        setMaximoNumeroIdentificacionReportante(15);
        setMinimoNumeroIdentificacionReportante(1);
        setIsDisabledIdentificacion(false);

        tiposDocs.forEach((value: any) => {
            if (value.$$href === tipoDocumento) {
                setIdDocumento(value.codigoTipoDoc)
                //Cedula de ciudadania/extranjeria
                if ('CEDULA DE CIUDADANIA' == value.descTipoDocumento
                    || 'CÉDULA DE EXTRANJERÍA' == value.descTipoDocumento) {
                    setMaximoNumeroIdentificacion(10);
                    setMinimoNumeroIdentificacion(3);
                    setValidarDato(true);
                }
                //pasaporte
                else if ('PASAPORTE' == value.descTipoDocumento) {
                    setMaximoNumeroIdentificacion(16);
                    setMinimoNumeroIdentificacion(3);
                }
                //registro civil v     //tarjeta de identidad
                else if ('REGISTRO CIVIL' == value.descTipoDocumento
                    || 'TARJETA DE IDENTIDAD' == value.descTipoDocumento) {

                    setMaximoNumeroIdentificacion(11);
                    setMinimoNumeroIdentificacion(10);
                }
                //salvo conducto - certificado nacido vivo
                else if ('SALVO CONDUCTO' == value.descTipoDocumento) {
                    setValidarDato(true);
                    setMaximoNumeroIdentificacion(9);
                    setMinimoNumeroIdentificacion(1);
                }
                else if ('CERTIFICADO DE NACIDO VIVO' == value.descTipoDocumento) {
                    setValidarDato(true);
                    setMaximoNumeroIdentificacion(14);
                    setMinimoNumeroIdentificacion(1);
                }
                else if ('OTRO' === value.descTipoDocumento) {
                    setValidarDato(true);
                    setIsDisabledIdentificacion(true);
                    setValueNumeroIdentificacion('99999999');
                    setValueNombrePaciente('NA');
                }
                else {
                    setMaximoNumeroIdentificacion(15);
                    setMinimoNumeroIdentificacion(3);
                    setMaximoNumeroIdentificacionReportante(15);
                    setMinimoNumeroIdentificacionReportante(3);
                }

            }

        });
    }

    const handleChangeSelectClinica = (ev: any) => {
        clinicas.forEach((value: any) => {
            if (value.$$title == ev.target.value) {
                setMotivoTramite(value.$$href)
            }

        })

        setSelectClinica(ev.target.value);
    };

    const handleChangeSelectTipoDoc = (ev: any) => {
        setValueNumeroIdentificacion(ev.target.value);
        ValidacionMaximoMinimo(ev.target.value);
        setSelectTipoId(ev.target.value);
    };

    const handleChangeSelectFechaOcurrencia = (ev: any) => {
        setStartOcurrenceDate(ev)

        if (!startOcurrenceDate) {
            setRequeridoFechaOcurrencia(true)
        }

    };

    const handleChangeSelectReportante = (ev: any) => {

        setSelectReportante(ev.target.value);
    };

    if (tiposDocs && tiposDocs.length > 0) {
        listDocs = <ListDocs tiposDocs={tiposDocs}></ListDocs>
    }

    if (reportantes && reportantes.length > 0) {


        const reportantesOrdenado = [...reportantes].sort((a, b) =>
            a.$$title > b.$$title ? 1 : -1,
        );

        listReportantes = <ListReportantes reportantes={reportantesOrdenado}></ListReportantes>
    }

    if (clinicas && clinicas.length > 0) {
        lstClinicas = <ListClinicas clinicas={clinicas}></ListClinicas>
    }

    const onKeyDownFechaNacimiento = async (e: any) => {
        if (!startOcurrenceDate) {
            setRequeridoFechaOcurrencia(false)
        }
        else {
            setRequeridoFechaOcurrencia(true)
        }

    }
    
    return (
        <Container>
            <Row className="mb-4 mt-5">
                <Col><h1 id='h1title'>Registro de eventos asociados al paciente</h1></Col>
            </Row>
            <Row className="mb-3">
                <Col><small className='smallStyle'>Los campos marcados con ( <span className='spanAsterisk'>*</span> ) son obligatorios</small></Col>
            </Row>
            <Row>
                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                    <Row className="mb-3">
                        <Form.Group as={Col} md="6">
                            <Form.Label>Tipo de identificación del paciente <span className='spanAsterisk'>*</span></Form.Label>
                            <Form.Control
                                id="tipo_identificacion"
                                required
                                as="select"
                                type="select"
                                name="tipo_identificacion"
                                value={selectTipoId}
                                className='inputStyleColors form-select'
                                onChange={(ev) => handleChangeSelectTipoDoc(ev)}>
                                <option value="" hidden>Selecciona una opción</option>
                                {listDocs}
                            </Form.Control >
                            <Form.Control.Feedback type="invalid">
                                Campo requerido
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group as={Col} md="6" controlId="numero_identificacion">
                            <Form.Label>Número de identificación del paciente <span className='spanAsterisk'>*</span></Form.Label>
                            <Form.Control

                                required
                                name="numero_identificacion"
                                value={valueNumerodeIdentificacion}
                                onBlur={onKeyDown}
                                onChange={handleChange}
                                placeholder="Ingresa el número de identificación"
                                defaultValue=""
                                maxLength={MaximoNumeroIdentificacion}
                                minLength={MinimoNumeroIdentificacion}
                                className='inputStyleColors'
                                disabled={isDisabledIdentificacion}
                            />

                            <Form.Control.Feedback type="invalid">
                                Campo requerido
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Row>
                    <Row className="mb-3">
                        <Form.Group as={Col} md="6" controlId="nombres_paciente">
                            <Form.Label>Nombres y apellidos del paciente <span className='spanAsterisk'>*</span></Form.Label>
                            <Form.Control
                                required
                                type="text"
                                value={valueNombrePaciente}
                                onChange={handleChange}
                                maxLength={250}
                                name="nombres_paciente"
                                placeholder="Ingresa los nombres y apellidos"
                                defaultValue=""
                                className='inputStyleColors'
                            />

                            <Form.Control.Feedback type="invalid">
                                Campo requerido
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group as={Col} md="6" controlId="aseguramiento">
                            <Form.Label>Aseguramiento</Form.Label>
                            <Form.Control
                                type="text"
                                value={valueAseguramiento}
                                onChange={handleChange}
                                maxLength={250}
                                name="aseguramiento"
                                placeholder="Ingrese la entidad de aseguramiento del paciente"
                                defaultValue=""
                                className='inputStyleColors'
                            />

                            <Form.Control.Feedback type="invalid">
                                Campo requerido
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Row>
                    <Row className="mb-3">
                        <Form.Group as={Col} md="6" controlId="fecha_ocurrencia">
                            <Form.Label>Fecha de ocurrencia del hecho <span className='spanAsterisk'>*</span></Form.Label>
                            <ReactDatePicker
                                placeholderText='AAAA-MM-DD'
                                required
                                selected={startOcurrenceDate}
                                onChange={(date: any) => handleChangeSelectFechaOcurrencia(date)}
                                className='form-control'
                                name='fecha_ocurrencia'
                                locale="es"
                                dateFormat="yyyy-MM-dd"
                                showIcon
                            />

                            <div hidden={requeridoFechaoOcurrencia} style={{
                                color: 'red', width: '80%',
                                marginTop: '.25rem', fontSize: '.875em'
                            }}>Campo requerido</div>
                        </Form.Group>
                        <Form.Group as={Col} md="6">
                            <Form.Label>Reportante <span className='spanAsterisk'>*</span></Form.Label>
                            <Form.Select
                                id="reportante"
                                required
                                as="select"
                                // type="select"
                                name="reportante"
                                value={selectReportante}
                                className='inputStyleColors form-select'
                                onChange={(ev) => handleChangeSelectReportante(ev)}
                            >
                                <option value="" hidden>Selecciona una opción</option>
                                {listReportantes}
                            </Form.Select >
                            <Form.Control.Feedback type="invalid">
                                Campo requerido
                            </Form.Control.Feedback>
                        </Form.Group>

                    </Row>
                    <Row className="mb-3">
                        <Form.Group as={Col} md="6" controlId="equipos_medicos">
                            <Form.Label>Equipos o dispositivos médicos</Form.Label>
                            <Form.Control

                                type="text"
                                maxLength={250}
                                name="equipos_medicos"
                                placeholder="Ingresa los equipos"
                                defaultValue=""
                                onChange={handleChange}
                                value={valueEquipos}
                                className='inputStyleColors'
                            />
                        </Form.Group>
                        <Form.Group as={Col} md="6" controlId="clinica">
                            <Form.Label>Clínica que registra el evento <span className='spanAsterisk'>*</span></Form.Label>
                            {/*TODO: completar campo */}
                            <Form.Control
                                required
                                as="select"
                                type="select"
                                name="clinica"
                                value={valueClinica}
                                className='inputStyleColors form-select'
                                onChange={(ev) => handleChangeSelectClinica(ev)}
                            >
                                <option value="" hidden>Selecciona una opción</option>
                                {lstClinicas}
                            </Form.Control >
                            <Form.Control.Feedback type="invalid">
                                Campo requerido
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Row>
                    <Row className="mb-3">
                        <Form.Group as={Col} md="6" controlId="fecha_nacimiento">
                            <Form.Label>Fecha de nacimiento</Form.Label>
                            <ReactDatePicker
                                placeholderText='AAAA-MM-DD'
                                name='fechaNacimiento'
                                selected={startBornDate}

                                onChange={(date: any) => setStartBornDate(date)}
                                className='form-control'
                                locale="es"
                                dateFormat="yyyy-MM-dd"
                                showIcon
                            />
                        </Form.Group>
                        <Form.Group as={Col} md="6" controlId="edad">
                            <Form.Label>Edad</Form.Label>
                            <Form.Control
                                type="text"
                                name="edad"
                                onChange={handleChange}
                                value={valueEdad}
                                maxLength={3}
                                minLength={1}
                                placeholder="Ingresa la edad"
                                defaultValue=""
                                className='inputStyleColors'
                            />

                            <Form.Control.Feedback type="invalid">
                                Campo requerido
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Row>
                    <Row className="mb-3">
                        <Form.Group as={Col} md="6">
                            <Form.Label>Género <span className='spanAsterisk'></span></Form.Label>
                            <Form.Control

                                type="text"
                                name="genero"
                                onChange={handleChange}
                                value={valueGenero}
                                maxLength={1}
                                minLength={1}
                                placeholder="Ingrese su genero"
                                defaultValue=""
                                className='inputStyleColors'
                            />
                            <Form.Control.Feedback type="invalid">
                                Campo requerido
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group as={Col} md="6" controlId="numero_reportante">
                            <Form.Label>Número de Documento de Quien Reporta</Form.Label>
                            <Form.Control
                                name="numero_reportante"
                                value={valueNumerodeIdentificacionReportante}
                                onBlur={onKeyDown}
                                onChange={handleChange}
                                placeholder="Ingresa el número de identificación de quien reporta"
                                defaultValue=""
                                maxLength={MaximoNumeroIdentificacionReportante}
                                minLength={MinimoNumeroIdentificacionReportante}
                                className='inputStyleColors'
                            />
                            <Form.Control.Feedback type="invalid">
                                Campo requerido
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Row>
                    <Row className="mb-3">
                        <Form.Group as={Col} md="12" controlId="descripcion_evento" className="mb-3">
                            <Form.Label>Descripción del evento <span className='spanAsterisk'>*</span></Form.Label>
                            <Form.Control
                                required
                                as="textarea"
                                name="descripcionevento"
                                onChange={handleChange}
                                value={valueDescripcionEvento}
                                maxLength={3000}
                                placeholder="Ingresa la descripción"
                                style={{ height: '100px' }}

                            />
                            <Form.Control.Feedback type="invalid">
                                Campo requerido
                            </Form.Control.Feedback>
                            <small className='smallTextArea'>Máximo 3000 caracteres</small>
                        </Form.Group>
                        <Form.Group as={Col} md="12" controlId="adjuntos" className="mb-3">

                            <Form.Label>Adjuntar archivos</Form.Label>
                            <input multiple className='form-control' onChange={ValidarTamano} type='file'></input>
                            <small className='smallStyle'>Tipo de formato: ZIP, PDF, XLSX, SLS, ODT, DOCX, PNG, JPG, JPEG. Máximo tamaño permitido 5:MB</small>
                        </Form.Group>

                        {/* TODO: completar campo  */}
                        <Form.Group as={Col} style={{ width: '100px', float:'right' }}>
                            <ReCAPTCHA   className='text-center' size='normal'  
                         sitekey={llave_recaptcha} onChange={Onchange2} />
                            <div hidden={recaptchaValido} style={{ color: 'red',width: '80%',
                                marginTop: '.25rem', fontSize: '.875em' }}>Campo requerido</div>
                        </Form.Group>                   
                        <Form.Group as={Col}>
                    </Form.Group>
                    </Row>

                    <Form.Group as={Col} style={{ width: '100%', float: 'right' }}>
                        <Spinner hidden={hiddenLoading} animation="border" variant="primary" />
                    </Form.Group>
                    <Form.Group className="mb-12 text-center">
                        <Button type='submit' size="lg" id='btnprimarySa' className="round mb-2" disabled={isDisabled}
                        >Enviar</Button>
                    </Form.Group>

                    {/* Modal dinamico para los mensajes que envian en la aplicación */}
                    <VerticallyModal showModal={setModalShow} hideModal={modalShow} titulo={valueTituloMensaje}
                        mensaje={valueCuerpoMensaje} radicacion={valueRadicacion}
                    ></VerticallyModal>
                </Form>
            </Row>
        </Container>
    )
}
